<script>
import { mapActions } from 'vuex'
export default {
  name: 'viewInvoiceDetail',
  props: ['stockOutId'],
  data() {
    return {
      loading: false,
      invoiceDetails: {}
    }
  },
  mounted() {
    this.onFetchData()
  },
  methods: {
    ...mapActions('saleInvoiceStore', ['onShow']),
    onFetchData() {
      this.loading = true
      this.onShow(this.stockOutId)
        .then(({ data }) => {
          this.invoiceDetails = data
        })
        .finally(() => (this.loading = false))
    },
    displayAmount(row, field) {
      let amount = row[field]
      if (
        row.input_currency_id !== row.currency_id &&
        row.input_currency_id !== null
      ) {
        amount = amount / parseFloat(row.fx_rate_ratio || 1)
      }

      if (row.currency_symbol) {
        return (
          row.currency_symbol +
          ' ' +
          this.$formatNumber(
            Math.round(amount, row.currency_rounding || 0),
            row.currency_rounding || 0
          )
        )
      }
      const defaultCurrencySign = this.$store.state.authUser.sys_setting
        .default_currency_sign
      return (
        defaultCurrencySign +
        ' ' +
        this.$formatNumber(
          Math.round(amount, row.currency_rounding || 0),
          row.currency_rounding || 0
        )
      )
    }
  }
}
</script>

<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-border ts-rounded ts-p-2">
      <div class="ts-grid ts-grid-cols-2 ts-gap-2">
        <div class="ts-flex ts-space-x-2">
          <label class="ts-text-gray-600 ts-font-thin ts-mb-0"
            >{{ $t('saleInvoice.invoiceDate') }}:
          </label>
          <p class="ts-mb-0 ts-font-medium">
            {{ invoiceDetails.stock_out_date }}
          </p>
        </div>
        <div class="ts-flex ts-space-x-2">
          <label class="ts-text-gray-600 ts-font-thin ts-mb-0"
            >{{ $t('saleInvoice.invoiceNumber') }}:
          </label>
          <p class="ts-mb-0 ts-text-blue-500 ts-font-medium">
            {{ invoiceDetails.invoice_no }}
          </p>
        </div>
        <div class="ts-flex ts-space-x-2">
          <label class="ts-text-gray-600 ts-font-thin ts-mb-0"
            >{{ $t('saleInvoice.refInvoice') }}:
          </label>
          <p class="ts-mb-0 ts-font-medium">
            {{
              invoiceDetails.reference_no ? invoiceDetails.reference_no : '-'
            }}
          </p>
        </div>
        <div class="ts-flex ts-space-x-2">
          <label class="ts-text-gray-600 ts-font-thin ts-mb-0"
            >{{ $t('saleInvoice.creditDay') }}:
          </label>
          <p class="ts-mb-0 ts-text-blue-500 ts-font-medium">
            {{ invoiceDetails.credit_day }}
          </p>
        </div>
        <div class="ts-flex ts-space-x-2">
          <label class="ts-text-gray-600 ts-font-thin ts-mb-0"
            >{{ $t('saleInvoice.saleName') }}:
          </label>
          <p class="ts-mb-0 ts-font-medium">{{ invoiceDetails.sale_name }}</p>
        </div>
        <div class="ts-flex ts-space-x-2">
          <label class="ts-text-gray-600 ts-font-thin ts-mb-0"
            >{{ $t('saleInvoice.createdBy') }}:
          </label>
          <p class="ts-mb-0 ts-font-medium">
            {{ invoiceDetails.user ? invoiceDetails.user.name : '' }}
          </p>
        </div>
      </div>
    </div>
    <div class="ts-border ts-rounded ts-p-2 ts-mt-3">
      <div class="ts-grid ts-grid-cols-2 ts-gap-2">
        <div class="ts-flex ts-space-x-2">
          <label class="ts-text-gray-600 ts-font-thin ts-mb-0"
            >{{ $t('saleInvoice.customerName') }}:
          </label>
          <p class="ts-mb-0 ts-font-medium">
            {{
              invoiceDetails.customer
                ? invoiceDetails.customer.customer_name
                : '-'
            }}
          </p>
        </div>
        <div class="ts-flex ts-space-x-2">
          <label class="ts-text-gray-600 ts-font-thin ts-mb-0"
            >{{ $t('saleInvoice.contactNumber') }}:
          </label>
          <p class="ts-mb-0 ts-font-medium">
            {{
              invoiceDetails.customer
                ? invoiceDetails.customer.contact_number
                : '-'
            }}
          </p>
        </div>
        <div class="ts-flex ts-space-x-2 ts-col-span-2">
          <label class="ts-text-gray-600 ts-font-thin ts-mb-0"
            >{{ $t('saleInvoice.address') }}:
          </label>
          <p class="ts-mb-0 ts-font-medium">
            {{
              invoiceDetails.customer ? invoiceDetails.customer.address_kh : '-'
            }}
          </p>
        </div>
      </div>
    </div>

    <h4 class="ts-text-gray-500 ts-mb-0 ts-mt-3">
      <i class="fas fa-shopping-basket"></i>
      {{ $t('saleInvoice.ordered') }}
    </h4>
    <div class="ts-border ts-rounded ts-p-2 ts-mt-1">
      <div class="grid-product">
        <div
          class="ts-text-center ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-py-2 ts-px-2 ts-whitespace-no-wrap"
        >
          {{ $t('saleInvoice.numeric') }}
        </div>
        <div
          class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-py-2 ts-px-2"
        >
          {{ $t('saleInvoice.product') }}
        </div>
        <div
          class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-py-2 ts-px-2 ts-text-center"
        >
          {{ $t('saleInvoice.quantity') }}
        </div>
        <div
          class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-py-2 ts-px-2"
        >
          {{ $t('saleInvoice.uom') }}
        </div>
        <div
          class="ts-uppercase ts-text-sm ts-font-semibold ts-text-right ts-bg-gray-200 ts-text-gray-700 ts-py-2 ts-px-2"
        >
          {{ $t('saleInvoice.unitPrice') }}
        </div>
        <div
          class="ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-py-2 ts-px-2"
        >
          {{ $t('saleInvoice.discountRate') }}
        </div>
        <div
          class=" ts-text-center ts-uppercase ts-text-sm ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-py-2 ts-px-2 ts-whitespace-no-wrap"
        >
          {{ $t('saleInvoice.vatRate') }}
        </div>
        <div
          class="ts-uppercase ts-text-sm ts-text-right ts-font-semibold ts-bg-gray-200 ts-text-gray-700 ts-py-2 ts-px-2"
        >
          {{ $t('saleInvoice.grandTotal') }}
        </div>
      </div>

      <div style="max-height: 350px; overflow-y: scroll;">
        <div
          v-for="(product, i) in invoiceDetails.details"
          class="grid-product"
          :key="i"
        >
          <div
            class="ts-text-center ts-py-2 ts-flex ts-items-center ts-pl-4 ts-border-t"
            :class="{ 'ts-bg-gray-100': i % 2 !== 0 }"
          >
            {{ i + 1 }}
          </div>
          <div
            class=" ts-py-2 ts-flex ts-items-center ts-px-2 ts-border-t"
            :class="{ 'ts-bg-gray-100': i % 2 !== 0 }"
          >
            <div>
              <p class="ts-mb-0 ts-text-blue-600 ts-font-semibold">
                {{ product.barcode + '-' + product.product_name_en }}
              </p>
              <p class="ts-mb-0 ts-text-xs">
                {{ product.serial_list.map(el => el.serial_no).join('|') }}
              </p>
            </div>
          </div>
          <div
            class=" ts-py-2 ts-flex ts-items-center ts-justify-center ts-px-2 ts-border-t"
            :class="{ 'ts-bg-gray-100': i % 2 !== 0 }"
          >
            {{ product.quantity }}
          </div>
          <div
            class=" ts-py-2 ts-flex ts-items-center  ts-px-2 ts-border-t"
            :class="{ 'ts-bg-gray-100': i % 2 !== 0 }"
          >
            {{ product.uom_name_en }}
          </div>
          <div
            class=" ts-py-2 ts-flex ts-items-center ts-whitespace-no-wrap ts-justify-end  ts-px-2 ts-border-t"
            :class="{ 'ts-bg-gray-100': i % 2 !== 0 }"
          >
            {{ displayAmount(product, 'unit_price') }}
          </div>
          <div
            class=" ts-py-2 ts-flex ts-items-center ts-justify-between ts-px-2 ts-border-t"
            :class="{ 'ts-bg-gray-100': i % 2 !== 0 }"
          >
            <p class="ts-mb-0">{{ product.discount_type }}</p>
            <p class="ts-mb-0">{{ product.discount_rate }}</p>
          </div>
          <div
            class=" ts-py-2 ts-flex ts-items-center ts-justify-center ts-px-2 ts-border-t"
            :class="{ 'ts-bg-gray-100': i % 2 !== 0 }"
          >
            <p class="ts-mb-0">{{ product.vat_rate }}</p>
          </div>
          <div
            class=" ts-py-2 ts-flex ts-items-center  ts-justify-end ts-px-2 ts-border-t"
            :class="{ 'ts-bg-gray-100': i % 2 !== 0 }"
          >
            {{ displayAmount(product, 'grand_total') }}
          </div>
        </div>
      </div>
      <div class="grid-footer ts-mt-3">
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1">
          {{ $t('saleInvoice.subTotal') }} :
        </div>
        <div
          class="ts-text-right ts-px-2 ts-border-t ts-py-1 ts-font-semibold ts-text-red-500"
        >
          {{ displayAmount(invoiceDetails, 'sub_total') }}
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1">
          {{ $t('saleInvoice.discountAmount') }} :
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1">
          {{ displayAmount(invoiceDetails, 'discount') }}
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1">
          {{ $t('saleInvoice.vatAmount') }} :
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1">
          {{ displayAmount(invoiceDetails, 'vat_amount') }}
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1">
          {{ $t('saleInvoice.grandTotal') }} :
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1">
          {{ displayAmount(invoiceDetails, 'grand_total') }}
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1">
          {{ $t('saleInvoice.amountPaid') }} :
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1 ts-text-blue-500">
          {{ displayAmount(invoiceDetails, 'amount_paid') }}
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1">
          {{ $t('saleInvoice.amountDue') }} :
        </div>
        <div class="ts-text-right ts-px-2 ts-border-t ts-py-1 ts-text-blue-500">
          {{ displayAmount(invoiceDetails, 'amount_due') }}
        </div>
      </div>
    </div>
  </ts-loading-banner>
</template>

<style scoped>
.grid-product {
  display: grid;
  grid-template-columns: 50px auto 120px 100px 120px 100px 100px 150px;
}
.grid-footer {
  display: grid;
  grid-template-columns: auto 150px;
}
</style>
